/***
 *
 *   VIEW
 *   The view houses global components that are common to all views
 *   (notification, modal), handles errors and renders the layout
 *
 **********/

import { useState, createContext, useContext } from 'react';
import {
	AppLayout,
	AuthLayout,
	HomeLayout,
	OnboardingLayout,
	Modal,
	ContentView,
	Notification,
	Loader,
	useNavigate,
	AppPlainLayout,
	PublicLayout,
	AppMobileLayout,
	useTranslation,
} from '../lib';
import { AuthContext } from 'components/lib';

// import './scss/normalize.scss';
// import './scss/view.scss';
// import './scss/typography.scss';

export const ViewContext = createContext();

export function View(props) {

	const { t } = useTranslation();
	const navigate = useNavigate();
	const authContext = useContext(AuthContext);
	// state
	const [notification, setNotification] = useState({ visible: 'hide', autoclose: true });
	const [modal, setModal] = useState({});
	const [contentView, setView] = useState({})
	const [loading, setLoading] = useState(false);

	// layouts
	const layouts = {
		app: AppLayout,
		home: HomeLayout,
		auth: AuthLayout,
		onboarding: OnboardingLayout,
		appPlain: AppPlainLayout,
		public: PublicLayout,
		appMobile: AppMobileLayout
	};

	// set title & layout
	document.title = t(props.title);
	let Layout = props.layout ? layouts[props.layout] : AppLayout;

	if (!props.display) return false;

	function showNotification(text, type, autoclose, format, icon) {
		setNotification({
			text: text,
			type: type,
			show: true,
			format: format,
			icon: icon,
			autoclose: autoclose,
		});

		if (autoclose) setTimeout(hideNotification, 3000);
	}
	function hideNotification() {
		setNotification({
			text: '',
			type: '',
			show: false,
			format: null,
			icon: null,
			autoclose: true,
		});
	}

	function showModal(content, callback) {
		
		let data = { ...modal };

		if (content) {
			for (let key in content) data[key] = content[key];

			data.show = true;
			data.callback = callback;
		}
		setModal(data);
	}

	function showView(content, callback) {
		let data = { ...contentView };

		if (content) {
			for (let key in content) data[key] = content[key];

			data.show = true;
			data.callback = callback;
		}
		setView(data);
	}

	function hideView(cancel, res) {
		setView({
			view: null,
			show: false,
		});
	}

	function hideModal(cancel, res) {
		// callback?
		if (!cancel && modal.callback) modal.callback(modal.form, res);

		// reset the modal
		setModal({
			title: null,
			text: null,
			buttonText: null,
			url: null,
			method: null,
			show: false,
		});
	}

	function handleError(err) {
		let message = t('global.error')
		if (err) {
			message = err.toString();

			if (err.response) {

				if (err.response.data?.message || err.response.data?.error) {
					message = err.response.data.message || err.response.data.error
				}

				if (err.response.status) {

					switch (err.response.status) {
						case 400:
							showNotification(message, 'error', false);
							break;

						case 401:
							authContext.signout()
							// navigate('/signin');
							break;

						case 404:
							navigate('/notfound');
							break;

						case 403:
							navigate('/nopermission');
							break;

						case 429:
							showNotification(err.response.data, 'error', false);
							break;

						case 402: // payment required
							navigate('/account/billing');
							showNotification(err.response.data.message, 'error', false);
							break;

						// case 500:
						//     navigate('/oops');
						//   break;

						default:
							showNotification(message, 'error', false);
							break;
					}
				}
			} else {
				showNotification(message, 'error', false);
			}
		}
	}

	const context = {
		notification: {
			show: showNotification,
			hide: hideNotification,
			data: notification,
		},
		t: t,
		modal: {
			show: showModal,
			hide: hideModal,
			data: modal,
		},
		contentView: {
			show: showView,
			hide: hideView,
			data: contentView
		},

		setLoading: (state) => setLoading(state),
		handleError: handleError,
	};

	return (
		<ViewContext.Provider value={context}>
			{notification.show && <Notification {...notification} />}

			{loading && <Loader fullScreen />}

			{modal.show && <Modal {...modal} />}

			{contentView.show && <ContentView {...contentView} />}

			<Layout navBar={props?.navBar} mobile={props?.mobile} title={props.title} data={props.data} hideNavItems={props.hideNavItems}>
				{/* <View t={t} /> */}
				{props.display}
			</Layout>
		</ViewContext.Provider>
	);
}
